import { lazy } from 'react';

// RaskhHome — the zero-choice Resume home (vision-aligned). Lazy so the
// protected-only chunk never lands in the public landing bundle. Mounted via
// the `raskhRoutes` spread already present in AppRoutes.jsx.
const RaskhHome = lazy(() => import('./RaskhHome'));

export const raskhRoutes = [
  { path: '/raskh', element: <RaskhHome /> },
  // /raskh/session is an alias for the same zero-choice surface so deep links
  // (and the AppRoutes skeleton map) resolve; the one Resume button routes the
  // learner onward into the concrete teach/review/add-source destination.
  { path: '/raskh/session', element: <RaskhHome /> },
];
